import {Component, EventEmitter, inject, Input, OnDestroy, Output} from '@angular/core';
import {RecordData, RecordDataValue, RecordTableColumnParams} from '../../../../types/records-table.types';
import {Subscription} from 'rxjs';
import {ValidationService} from "../../../../services/validation.service";
import {RecordsTableService} from "../../../../services/records-table.service";
import {DropdownSettingsStateService} from "../../../../services/dropdown-settings-state.service";
import {TableContextService} from "../../../../services/table-services/table-context.service";

@Component({
  selector: 'app-base-record-table-item',
  standalone: false,
  templateUrl: './base-record-table-item.component.html',
})
export class BaseRecordTableItemComponent implements OnDestroy {
  @Input({ required: true }) columnParam!: RecordTableColumnParams;
  @Input({ required: true }) value: RecordDataValue = null;
  @Input() record: RecordData | null = null;
  @Input({ required: true }) isEdit: boolean = false;
  @Input() isEditable: boolean = true;
  @Input() required: boolean = false;
  @Input() currentTableZoom: number = 1;
  @Input() useDynamicWidth: boolean = true;
  @Output() valueChanged: EventEmitter<RecordDataValue> = new EventEmitter<RecordDataValue>();

  protected dataSubscriptions: Subscription = new Subscription();
  protected validationService: ValidationService = inject(ValidationService);
  protected recordsTableService: RecordsTableService = inject(RecordsTableService);
  protected dropdownSettingsStateService: DropdownSettingsStateService = inject(DropdownSettingsStateService);
  protected tableContextService: TableContextService = inject(TableContextService);

  public ngOnDestroy() {
    this.dataSubscriptions.unsubscribe();
  }

  protected handleValueChange(value: RecordDataValue): void {
    const validValue = value ?
      this.validationService.validateDateComponent(value, this.columnParam.key) :
      null;
    if (!validValue && value) {
      this.value = '';
      return;
    }

    this.valueChanged.emit(value);
    if (this.record) {
      this.value = this.clearValueIfRecordValueEmpty(this.record) ? this.record[this.columnParam.key] : value;
    }
  }

  protected isPossibleToEdit(): boolean {
    return this.isEditable && this.isEdit;
  }

  protected getStringValue(): string {
    if (this.value === null || this.value === undefined) { this.value = ''; }

    return this.value as string;
  }

  protected clearValueIfRecordValueEmpty(record: RecordData): boolean {
    return !record[this.columnParam.key] || record[this.columnParam.key] !== this.value;
  }

  protected preventDrag(event: DragEvent): void {
    event.preventDefault();
  }

  protected getWidth(): number {
    return this.recordsTableService.getColumnWidth(this.columnParam, this.tableContextService.getTableId());
  }
}
